// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const pesel: CountryValidator<"PL", ParsedPersonId> =
  createValidator("pl.pesel", 146);

export default pesel;
export const compact = pesel.compact;
export const format = pesel.format;
export const validate = pesel.validate;
export const generate = (): string =>
  pesel.generate?.() ??
  (() => {
    throw new Error(
      "Validator pl.pesel cannot generate values",
    );
  })();
export const parse = pesel.parse;
